export default __webpack_public_path__ + "static/media/PFDINTextPro-Bold.758af7b6.otf";